<div id="page-container">
  <!-- <headband [accountName]="accountName" [maxVoters]="maxVoters" [hasHotline]="hasHotline"
    (hotlinePopupChange)="hotlinePopup = $event" (optionsPopupChange)="changeSubscription()"></headband> -->
  <div class="fullScreen">
    <div class="account-header content-between align-items-center">
      <div class="flex gap-10 align-items-center h-full">
        <div class="version">
          <p class="no-margin text-sm yellow"><span class="text-xs">Version</span><br>{{version}}</p>
        </div>
        <img src="assets/home-page-white-icon.svg" style="height: 18px;" class="pointer" (click)="backArrow()">
      </div>

      <div *ngIf="maxVoters === 5" class="flex content-between h-fit gap-10" style="width: 100%;">
        <p class="banner-text no-margin" id="txt" style="margin-left: 10px;">
          {{'POLL-DASHBOARD.HEADBAND.MESSAGE-CREATION-SHORT' | translate}}
        </p>
        <div class="flex gap-10 align-items-center">
          <p class="banner-text no-margin" id="txt2">
            {{accountName}}
          </p>
          <img src="assets/power_settings_new_24px.svg" class="power-button" (click)="logout()"
            style="cursor: pointer; " loading="lazy">
        </div>
      </div>

      <div *ngIf="maxVoters > 5" class="flex content-between h-fit gap-10" style="margin-right: 20px;">
        <div *ngIf="hasHotline">
          <p class="banner-text hotline-display no-margin">
            {{'POLL-DASHBOARD.HEADBAND.PHONE' | translate}}
          </p>
        </div>

        <p class="banner-text no-margin h-fit" *ngIf="licenseTime == 'D'">
          {{accountName}} - {{'POLL-DASHBOARD.HEADBAND.EVENTS' | translate}}
        </p>
        <p class="banner-text no-margin h-fit" *ngIf="licenseTime == 'DM'">
          {{accountName}} - {{eventCounter}} {{'POLL-DASHBOARD.HEADBAND.PACK' | translate}}
        </p>
        <p class="banner-text no-margin h-fit" *ngIf="licenseTime == 'Y'">
          {{accountName}} - {{'POLL-DASHBOARD.HEADBAND.YEARLY' | translate}}
        </p>
        <img src="assets/power_settings_new_24px.svg" (click)="logout()" loading="lazy"
          style="cursor: pointer; height: 18px; width:18px;">

      </div>
    </div>

  </div>
  <div class="profile-page">
    <div class="left-side">
      <img src="assets/v8te.png" id="v8te-logo" style="margin-top: 60px;" (click)="backArrow()" loading="lazy">
      <div style="height: 40px"></div>
      <div class="profile-tab" (click)="setStatus(0)">
        <img *ngIf="status === 0" src="assets/profile-account-sel.svg">
        <img *ngIf="status !== 0" src="assets/profile-account-desel.svg">
        <div [ngClass]="status == 0 ? 'tab-active' : 'tab-inactive'">{{'PROFILE.ACCOUNT-TITLE' | translate}}</div>
      </div>
      <div class="profile-tab" *ngIf="shouldDisplayChangePassword()" (click)="setStatus(1)">
        <img *ngIf="status === 1" src="assets/profile-pass-sel.svg">
        <img *ngIf="status !== 1" src="assets/profile-pass-desel.svg">
        <div [ngClass]="status == 1 ? 'tab-active' : 'tab-inactive'">{{'PROFILE.PASS-TITLE' | translate}}</div>
      </div>
      <div class="profile-tab" (click)="setStatus(2)">
        <img *ngIf="status === 2" src="assets/profile-invoices-sel.svg">
        <img *ngIf="status !== 2" src="assets/profile-invoices-unsel.svg">
        <div [ngClass]="status == 2 ? 'tab-active' : 'tab-inactive'">{{'PROFILE.OFFER-TITLE' | translate}}</div>
      </div>
      <div class="profile-tab" (click)="toRoles()">
        <img *ngIf="status === 3" src="assets/election-simple-selected.svg" style="height: 38px; width: 24px">
        <img *ngIf="status !== 3" src="assets/election-simple-black.svg" style="height: 38px; width: 24px">
        <div [ngClass]="status == 3 ? 'tab-active' : 'tab-inactive'">Gestion des accès</div>
      </div>
    </div>
    <div class="right-side">
      <div class="arrow-container" style="display: flex; margin-top: 30px;">
        <img (click)="backArrow()" data-cy="back-button" src="assets/arrow-left.svg" style="cursor: pointer;"
          loading="lazy">
        <div style="width: 5px"></div>
        <h3 *ngIf="status == 0" class="title-main">{{'PROFILE.ACCOUNT-TITLE' | translate}}</h3>
        <h3 *ngIf="status == 1" class="title-main">{{'PROFILE.PASS-TITLE' | translate}}</h3>
        <h3 *ngIf="status == 2" class="title-main">{{'PROFILE.OFFER-TITLE' | translate}}</h3>
        <h3 *ngIf="status == 3" class="title-main">{{'PROFILE.SHARED-ACCOUNT' | translate}}</h3>
      </div>
      <div *ngIf="status === 0" class="data-holder">
        <div *ngIf="shouldDisplayChangePassword()">
          <div class="input-title">{{'PROFILE.EMAIL' | translate}}</div>
          <textarea id="email" class="name" maxlength="140" value="{{authenticationService.getUserData()}}"
            readonly></textarea>
          <div class="input-title">{{'PROFILE.EMAIL-NEW' | translate}}</div>
          <textarea id="email-new" class="name" maxlength="140"
            placeholder="{{'CHANGE-VOTER.MAIL-NEW' | translate}}"></textarea>
          <div class="input-title">{{'PROFILE.EMAIL-CONFIRM' | translate}}</div>
          <textarea id="email-new-confirm" class="name" maxlength="140"
            placeholder="{{'CHANGE-VOTER.MAIL-CONFIRM' | translate}}"></textarea>
          <button class="blue-button" style="margin-top: 18px"
            (click)="displayMailChangeAnnouncement()">{{'PROFILE.UPDATE' | translate}}</button>
        </div>
        <div (click)="logout()" class="red-link">{{'PROFILE.LOGOUT' | translate}}</div>
        <div (click)="displayDeleteWarning()" class="gray-link">{{'PROFILE.DELETE-ACCOUNT' | translate}}</div>
      </div>
      <div *ngIf="status === 1" class="data-holder">
        <div class="gray-description">{{'PROFILE.CHANGE-PASSWORD' | translate}}</div>
        <div style="width: 100%; display: flex; justify-content: center; margin-top: 16px">
          <button class="blue-button" style="margin-top: 18px"
            (click)="displayPasswordAnnouncement()">{{'PROFILE.UPDATE' | translate}}</button>
        </div>
      </div>
      <div *ngIf="status === 2" class="data-holder" style="width: 50%">
        <div class="input-title">{{'PROFILE.OFFER-HEADER' | translate}}</div>
        <div class="gray-description" style="white-space: pre-wrap; margin-top: 18px">{{offer}}</div>
        <div style="height: 16px;"></div>
        <div *ngIf="invoices.length > 0" class="input-title">{{'PROFILE.OFFER-INVOICES' | translate}}</div>
        <a *ngFor="let invoice of invoices" href="{{invoice}}}"
          style="overflow: hidden; display: block">{{invoice}}<br></a>
      </div>
      <div *ngIf="status === 3" class="data-holder">
        <div *ngIf="peers.length > 0" class="input-title" style="margin-bottom: 8px">Compte(s) partagé(s) ajouté(s) :
        </div>
        <div *ngFor="let peer of peers" style="margin-bottom: 12px">
          <div class="data-holder-plus">
            <div class="peer-listing">{{ peer.email }}</div>
            <img src="assets/deletebuttonred.svg" style="cursor: pointer"
              (click)="displayDeleteLinkMessage(peer.id, peer.email)">
          </div>
        </div>
        <div *ngIf="peers.length > 0" style="height: 12px"></div>
        <div class="input-title">{{'PROFILE.ADD-SUB-ACCOUNT' | translate}}</div>
        <textarea id="input-sec-account" class="name" maxlength="140"
          placeholder="{{'PROFILE.SUB-ACCOUNT-PLACEHOLDER' | translate}}"></textarea>
        <button class="blue-button" style="margin-top: 18px" (click)="addSecondaryAccount()">{{'PROFILE.ADD' |
          translate}}</button>
      </div>
    </div>
  </div>
  <vc-warning-popup *ngIf="shouldDisplayDeletionWarning" title="{{ 'VOTERS-INVALID-POPUP.TITLE-1' | translate}}"
    firstText="{{'PROFILE.DELETE-MESSAGE' | translate}}" deleteButton="true" cancelButton="true"
    (endDetailsPopup)="deleteAccount($event)"></vc-warning-popup>
  <vc-warning-popup *ngIf="shouldDisplayPasswordMessage" firstText="{{'PROFILE.PASS-CHANGE-MESSAGE' | translate}}"
    confirmButton="true" (endDetailsPopup)="dismissPassChangePopups()"></vc-warning-popup>
  <vc-warning-popup *ngIf="shouldDisplayMailMessage" firstText="{{'PROFILE.MAIL-CHANGE-MESSAGE' | translate}}"
    confirmButton="true" (endDetailsPopup)="dismissMailChangePopups()"></vc-warning-popup>
  <vc-warning-popup *ngIf="shouldDisplaySecondaryDeleteMessage"
    firstText="{{'PROFILE.DELETE-SUB-MESSAGE' | translate}}{{peerNameToDelete}} ?" deleteButton="true"
    cancelButton="true" (endDetailsPopup)="deleteLink($event)"></vc-warning-popup>
  <!-- <buy-options-popup *ngIf="shoulDisplayChangePopup" (endDetailsPopup)="dismissInitialPopup()"
    [licenseTime]="licenseTime" [isAssoc]="clientType == 'assoc'" (isClosed)="dismissChangePopup()"
    [SMSOffers]="smsAdditionalOption" (SMSOptionEmitter)="setSMSOption($event)"
    (hotlineOptionEmitter)="licenseService.setHotlineOption($event, isAssoc)"></buy-options-popup> -->
</div>